export default __webpack_public_path__ + "static/media/programs.9f910c1a.svg";